import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'classnames';
import React from 'react';

var styles = require('./Heading-styles.module.css');

function Header(_ref) {
  var level = _ref.level,
      props = _objectWithoutPropertiesLoose(_ref, ["level"]);

  var Tag = level == null || level > 6 ? 'header' : "h" + Math.min(level, 6);
  return /*#__PURE__*/React.createElement(Tag, Object.assign({}, props, {
    className: classNames(props.className, styles.Heading, styles[Tag])
  }));
}

export default Header;